import { ethers } from 'ethers';
import { v4 as uuidv4 } from 'uuid';
import {
  TransactionActions,
  handleTransactionActions,
  invariant,
} from '@orionprotocol/common';
import { useDispatch } from 'react-redux';

import { Tx, transactionsSlice } from '../slices';
import { useWalletAddress, useAppChainId } from '../../api';
import { Contracts } from '../../types';

type Props = {
  unsignedTx: ethers.TransactionLike;
  summary: string;
  contract?: Contracts;
} & TransactionActions &
  Partial<Tx>;

type UseAddTxToQueueActionReturnType = (props: Props) => void;

export const useAddTxToQueue = (): UseAddTxToQueueActionReturnType => {
  const walletAddress = useWalletAddress();
  const chainId = useAppChainId();
  const dispatch = useDispatch();

  const addTxToQueue = ({
    unsignedTx,
    confirmations,
    summary,
    value,
    gasLimit,
    gasPrice,
    // isReversedOrder,
    payload,
    onTxIncludedInChain,
    onTxSent,
    onTxFail,
    onTxSuccess,
    onTxError,
    onTxFinal,
    contract,
  }: Props): void => {
    invariant(
      walletAddress !== undefined,
      "Can't add transaction to queue without wallet address",
    );

    const id = uuidv4();

    handleTransactionActions({
      id,
      onTxFail,
      onTxError,
      onTxFinal,
      onTxIncludedInChain,
      onTxSent,
      onTxSuccess,
    });
    dispatch(
      transactionsSlice.actions.addTransactionToQueue({
        id,
        datetime: Date.now(),
        gasLimit,
        gasPrice,
        from: walletAddress,
        summary,
        value: value ?? unsignedTx.value?.toString(),
        to: unsignedTx.to,
        data: unsignedTx.data,
        chainId,
        payload,
        confirmations,
        // isReversedOrder,
        contract,
      }),
    );
  };

  return addTxToQueue;
};
